import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import _ from "lodash";
import { classNames } from "Constants";
import LocaleStrings from "Languages";

function BadgeForUsersListItem(props) {
  let { appUser, badgeFor, selectedUsers, generateSingleBadge } = props;
  const [update, setupdate] = useState(false);

  useEffect(() => {
    return () => {};
  }, []);

  const _handleChange = (e, item) => {
    setupdate(!update);
    props.checkAndUncheckUsers(item);
  };

  const printBadge = (item) => {
    // console.log("item", item);
    generateSingleBadge(item);
  };

  let isChecked = false; // Initialization
  var index = _.findIndex(selectedUsers, function (curuser) {
    return curuser.appuserid === appUser.appuserid;
  });
  if (index >= 0) {
    isChecked = true;
  }

  return (
    <tr key={appUser.dfid}>
      {/* Check box */}
      <td style={{ width: "10%", textAlign: "center" }}>
        <label
          className={classNames(
            badgeFor === "choose_attendees" ? "checkcontainer" : "hidden",
            ""
          )}
        >
          <input
            type="checkbox"
            onChange={(e) => {
              _handleChange(e, appUser);
            }}
            checked={isChecked}
            // disabled={isDisabled}
          />
          <span className="checkcheckmark" disabled={false} />
        </label>
      </td>
      {/* Name */}
      <td>
        {appUser.username}
        {appUser.isadmin === true ? (
          <span className="label-mandatory"> ({LocaleStrings.admin})</span>
        ) : (
          ""
        )}
      </td>
      <td>
        <button
          className="btn btn-custom-table-blue"
          type="button"
          onClick={() => printBadge(appUser)}
        >
          {LocaleStrings.button_print}
        </button>
      </td>
    </tr>
  );
}

function mapStateToProps(state) {
  return {
    session: state.session,
  };
}

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BadgeForUsersListItem);
